export const BENEFITS_ALERT_COPY = {
  benefits_alert_title:
    "Benefits will be terminated at the end of their separation month",
};
